module.exports = __webpack_public_path__ + "img/datacenter.4ff6b716.png";